export const Close = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.52"
      height="25.52"
      viewBox="0 0 25.52 25.52"
    >
      <g
        id="Group_1995"
        data-name="Group 1995"
        transform="translate(-1280.112 -202.113)"
      >
        <g
          id="Group_1940"
          data-name="Group 1940"
          transform="translate(1280.112 202.113)"
        >
          <rect
            id="Rectangle_2096"
            data-name="Rectangle 2096"
            width="2.831"
            height="33.26"
            rx="1.415"
            transform="translate(23.519) rotate(45)"
            fill="red"
          />
          <rect
            id="Rectangle_2097"
            data-name="Rectangle 2097"
            width="2.831"
            height="33.26"
            rx="1.415"
            transform="translate(0 2.002) rotate(-45)"
            fill="red"
          />
        </g>
      </g>
    </svg>
  );
};
